import { MouseEvent } from 'react'
import { Cell } from 'recharts'
import { TargetPriceGraphData } from '../useBomItemDetails'
import { TargetPriceTooltipTypes } from './Tooltips/TargetPriceTooltip'

export const TargetPriceCell = (props: {
  data: TargetPriceGraphData[]
  onMouseEnter: (
    e: MouseEvent,
    data: TargetPriceGraphData,
    tooltipDataType: TargetPriceTooltipTypes
  ) => void
  field?: keyof TargetPriceGraphData
  fill?: (data: TargetPriceGraphData) => string
  tooltipDataType: TargetPriceTooltipTypes
}) => {
  return props.data.map((d, i) => {
    let data: TargetPriceGraphData = undefined
    if (props.field) {
      data = {
        id: d.id,
        description: d.description,
        sharedCost: d.sharedCost,
        matchDescription: d.matchDescription,
        [props.field]: d[props.field],
      }
    }
    return (
      <Cell
        key={`cell-${i}-${d.description}`}
        onMouseEnter={(e) =>
          props.onMouseEnter(e, data || d, props.tooltipDataType)
        }
        onMouseLeave={(e) =>
          props.onMouseEnter(e, undefined, props.tooltipDataType)
        }
      />
    )
  })
}
